<ng-container *ngFor="let person of people; let i = index;">
  <wo-contact-person *ngIf="person" [person]="person" />
  <iss-horizontal-line *ngIf="i < people!.length - 1"/>
</ng-container>
